import { render, staticRenderFns } from "./ModelFormModal.vue?vue&type=template&id=6f2de380&scoped=true"
import script from "./ModelFormModal.vue?vue&type=script&lang=ts"
export * from "./ModelFormModal.vue?vue&type=script&lang=ts"
import style0 from "./ModelFormModal.vue?vue&type=style&index=0&id=6f2de380&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2de380",
  null
  
)

export default component.exports